import axios from 'axios';

const getList = params => axios.get('compras/aprovacoes', { params });

const get = id => axios.get(`compras/aprovacoes/${id}`);

const getRecusadas = id => axios.get(`compras/aprovacoes/${id}/recusadas`);

const getProduto = (id, idProduto) => axios.get(`compras/aprovacoes/${id}/produtos/${idProduto}`);

const aprovarProdutos = (idAprovacao, data) => axios.put(`compras/aprovacoes/${idAprovacao}/aprovar`, data);

const recusarProdutos = (idAprovacao, data) => axios.put(`compras/aprovacoes/${idAprovacao}/recusar`, data);

const getLinks = id => axios.get(`/compras/aprovacoes/${id}/links`);

const gerarCompraParcial = (idAprovacao, data) => axios.put(`compras/aprovacoes/${idAprovacao}/gerar-compras`, data);

export default {
  get,
  getRecusadas,
  getProduto,
  getList,
  getLinks,
  aprovarProdutos,
  recusarProdutos,
  gerarCompraParcial,
};
